import React from "react";

const AuthLayout = ({ children }) => {
  return (
    <>
      <section
        className="AuthPage position-relative d-flex align-items-center justify-content-center"
        style={{ background: "#FFFBF2" }}
      >
        <div className="container-fluid">
          <div className="justify-content-end">
              <div className="formInner">
                <div className="logo text-center">
                  <img
                    src={"../assets/images/logo-removebg-preview.png"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
                {children}
              </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AuthLayout;
